import { StackScreenProps } from "@react-navigation/stack";
import { Button, Page } from "@towersystems/roam-common-native";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Colors, View } from "react-native-ui-lib";
import Editor from "react-simple-wysiwyg";
import { ProductFormValues } from "../../components/ProductForm/types";
import { useTranslation } from "../../../../utilities/i18n";

export const RichTextEditor = ({
  disabled,
  onContentChange,
  value = "",
}: {
  disabled?: boolean;
  onContentChange: (t: any) => void;
  value: string;
}) => {
  return (
    <View>
      <View
        style={{
          borderWidth: 1,
          borderColor: Colors.inputBorderColor,
          borderBottomEndRadius: 4,
          borderBottomStartRadius: 4,
          backgroundColor: disabled ? "#e4e4e4" : Colors.input,
        }}
      >
        <Editor
          style={{
            height: 200,
          }}
          disabled={disabled}
          value={value}
          onChange={onContentChange}
        ></Editor>
      </View>
    </View>
  );
};

export interface ProductDescriptionReviewScreenProps
  extends StackScreenProps<any, "ProductDescriptionReviewScreen"> {}

export const ProductDescriptionReviewScreen = ({
  navigation,
  route,
}: ProductDescriptionReviewScreenProps) => {
  const { generatedDescription = "" } = route.params || {};
  const [description, setDescription] = React.useState(generatedDescription);
  const { setValue: setProductFormValue } = useFormContext<ProductFormValues>();
  const { t } = useTranslation("product");

  const handleOnSubmit = () => {
    setProductFormValue("description", description, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.getParent()?.goBack();
  };

  const footerMarkup = (
    <Button
      label={t("button.submit_generated_ai_description")}
      backgroundColor={Colors.action}
      color="white"
      onPress={handleOnSubmit}
    ></Button>
  );

  return (
    <Page
      title="Review Generated Description"
      secondaryTitle="Review and make any edits before completing."
      footer={footerMarkup}
    >
      <RichTextEditor
        value={description}
        onContentChange={(t) => setDescription(t)}
      />
    </Page>
  );
};
